import React, { useState } from 'react'
import AboutUsImage from '../../../assets/images/front/about-us.jpg'
import ArrowRightGreenIcon from '../../../assets/images/front/svg/arrow-right-green.svg'
import ArrowRightBlueIcon from '../../../assets/images/front/svg/arrow-right-blue.svg'
import PersonIcon1 from '../../../assets/images/front/users/person-1.png'
import PersonIcon2 from '../../../assets/images/front/users/person-2.png'
import PersonIcon3 from '../../../assets/images/front/users/person-3.png'
import PersonIcon4 from '../../../assets/images/front/users/person-4.png'
import PersonIcon5 from '../../../assets/images/front/users/person-5.png'
import PersonIcon6 from '../../../assets/images/front/users/person-6.png'
import { routesURLs } from '../../../Routes'
import { useHistory } from 'react-router-dom'

const people = [
  {
    name: 'Ing. Jiří Žežulka',
    role: 'ZAKLADATEL',
    img: PersonIcon1
  },
  {
    name: 'Mgr. Barbora Vondrová',
    role: 'ORGANIZACE PŘÍPRAVNÝCH KURZŮ A SPRÁVA ON-LINE ŠKOLY',
    img: PersonIcon2,
    text: `Zajišťuji hladký průběh přípravných kurzů a správu online školy. Dbám na to, aby vše
    fungovalo a studenti měli vždy potřebné informace a podporu.`
  },
  {
    name: 'Mgr. JOHANA DMOCHOVSKÁ',
    role: 'ORGANIZACE OSOBNÍHO DOUČOVÁNÍ',
    img: PersonIcon3,
    text: `Koordinuji osobní doučování a pomáhám studentům najít nejvhodnějšího lektora pro
    jejich potřeby. Každý student je pro mě důležitý.`
  },
  {
    name: 'Ing. PŘEMYSL MIKA',
    role: 'ROZVOJ FIRMY A ORGANIZACE',
    img: PersonIcon4,
    text: `Starám se o rozvoj firmy a organizaci vnitřních procesů. Mým cílem je, aby naše
    služby byly stále lepší a dostupnější.`
  },
  {
    name: 'Adéla Kořenková',
    role: 'ADMINISTRATIVA',
    img: PersonIcon5,
    text: `Zajišťuji administrativní podporu a komunikaci s rodiči i studenty. Ráda pomohu s
    jakýmkoliv dotazem.`
  },
  {
    name: 'Mgr. Kateřina Žežulková',
    role: 'Vedoucí pedagog',
    img: PersonIcon6,
    text: `Jako vedoucí pedagog dohlížím na kvalitu výuky a rozvoj lektorů. Dbám na to, aby
    každý student dostal tu nejlepší péči.`
  }
]

const AboutUs: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const history = useHistory()

  const handleAccordionClick = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx)
  }

  return (
    <>
      <div className="container mt-[52px] md:mt-[88px] py-6 md:py-12 mx-4 px-4">
        <h1 className="text-[#0183BA] mb-3 text-xl md:text-[25px] text-center">O nás</h1>
        <div className="grid grid-cols-12 gap-4 mb-[30px] md:mb-[60px]">
          <div className="col-span-12 sm:hidden">
            <img src={AboutUsImage} alt="" className="block w-full rounded-3xl" />
          </div>
          <div className="col-span-12 sm:col-span-8 px-4 lg:px-0">
            <p className="mb-3">
              Více než 10 let pomáháme žákům základních škol uspět u přijímacích zkoušek na střední
              školy a zlepšit jejich znalosti i prospěch. Naším cílem je pomoci co nejvíce dětem
              zažít úspěch ve škole. Ukázat jim, že učení nemusí být jen nuda a že s nově nabytým
              sebevědomím se mohou do školy dokonce i těšit.
            </p>
            <p className="mb-3">
              Náš tým tvoří několik desítek lektorů, kteří procházejí pravidelným školením s
              profesionálními pedagogy (lektory našich přípravných kurzů). Vždy používáme
              nejvhodnější vyučovací metody a zároveň klademe důraz na individuální přístup.
            </p>
            <p>
              Jsme si jisti, že s námi budete spokojeni a věříme, že vašemu dítěti pomůžeme získat
              potřebné vědomosti a zkušenosti.
            </p>
          </div>
          <div className="hidden sm:block col-span-4">
            <img src={AboutUsImage} alt="" className="block w-full rounded-3xl" />
          </div>
        </div>
        <h2 className="text-[#0183BA] mb-2 md:mb-8 text-xl md:text-[25px] text-center">
          Naše hlavní služby
        </h2>
        <div className="grid grid-cols-12 gap-4 px-6 md:px-0">
          <div className="hidden md:block col-span-1">&nbsp;</div>
          <div className="col-span-12 sm:col-span-6 md:col-span-4 flex flex-col items-start">
            <h3 className="text-xl md:text-[25px] text-[#A8CD00]">Příprava na přijímací zkoušky</h3>
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start">
                <img src={ArrowRightGreenIcon} alt="" className="mt-1 me-1" />
                Skupinová příprava
              </li>
              <li className="flex items-start">
                <img src={ArrowRightGreenIcon} alt="" className="mt-1 me-1" />
                On-line kurzy
              </li>
              <li className="flex items-start">
                <img src={ArrowRightGreenIcon} alt="" className="mt-1 me-1" />
                Přijímačky nanečisto
              </li>
            </ul>
          </div>
          <div className="col-span-2 hidden md:block">&nbsp;</div>
          <div className="col-span-12 sm:col-span-6 md:col-span-4 flex flex-col items-start">
            <h3 className="text-xl md:text-[25px] text-[#0183BA]">Individuální doučování</h3>
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start">
                <img src={ArrowRightBlueIcon} alt="" className="mt-1 me-1" />
                Osobní
              </li>
              <li className="flex items-start">
                <img src={ArrowRightBlueIcon} alt="" className="mt-1 me-1" />
                Online
              </li>
            </ul>
          </div>
          <div className="col-span-1 hidden md:block">&nbsp;</div>
        </div>
      </div>
      <div className="w-full py-5 bg-[#00A0E3] -mb-12 px-4 lg:px-0">
        <div className="max-w-[720px] mx-auto mx-auto md:px-4 flex flex-col gap-2">
          {people.map((person, idx) => (
            <div
              key={person.name}
              className={`px-6 py-1 bg-white rounded-lg flex items-start cursor-pointer hover:bg-[rgba(255,255,255,0.85)] transition-all duration-300 ${
                openIndex === idx ? 'shadow-lg' : ''
              }`}
              onClick={() =>
                !person.text ? history.push(routesURLs.founder) : handleAccordionClick(idx)
              }
            >
              <img
                src={person.img}
                className="block rounded-full w-[60px] h-[60px] object-cover me-6"
                alt=""
              />
              <img
                src={ArrowRightBlueIcon}
                alt=""
                className={`me-2 h-4 w-2 mt-4.5 accordion-arrow-right transition-transform duration-300 mt-4 ${
                  openIndex === idx ? 'rotate-90' : ''
                }`}
              />
              <div className="flex flex-col justify-start leading-none">
                <div className="text-xl text-[#0183BA]">{person.name}</div>
                <div className="text-xl text-[#A8CD00]">{person.role}</div>
                <p
                  className={`leading-normal overflow-hidden transition-all duration-500 ${
                    openIndex === idx ? 'block' : 'hidden'
                  }`}
                >
                  {person.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default AboutUs
